module.exports = __webpack_public_path__ + "static/media/Galileo_playerAttack.b3cd7be4.wav";


//////////////////
// WEBPACK FOOTER
// ./src/sound/Galileo_playerAttack.wav
// module id = 190
// module chunks = 0